export interface RequiredProductEntry {
    category: string;
    manufacturerProductId: string;
    productName: string;
    formulaProductName?: string;
}

export interface ParentProductMapping {
    parentManufacturerProductId: string;
    parentProductName: string;
    requiredProducts: RequiredProductEntry[];
}

export interface ProductDependencyRule {
    category: string;
    requiresCategories: string[];
    mappings: ParentProductMapping[];
}

export interface ProductDependenciesConfig {
    version: number;
    rules: ProductDependencyRule[];
}

/** Legacy shape used by schema builder and clear-product handlers */
export interface LegacyDependencyRule {
    Category: string;
    RequiresCategories: string[];
    Mappings: Array<{
        Product: string;
        parentManufacturerProductId?: string;
        RequiredProducts: Array<{
            Category: string;
            Product: string;
            manufacturerProductId: string;
            formulaProductName?: string;
        }>;
    }>;
}

export function toLegacyDependencyRules(config: ProductDependenciesConfig): LegacyDependencyRule[] {
    return config.rules.map((rule) => ({
        Category: rule.category,
        RequiresCategories: rule.requiresCategories,
        Mappings: rule.mappings.map((mapping) => ({
            Product: mapping.parentProductName,
            parentManufacturerProductId: mapping.parentManufacturerProductId,
            RequiredProducts: mapping.requiredProducts.map((req) => ({
                Category: req.category,
                Product: req.productName,
                manufacturerProductId: req.manufacturerProductId,
                formulaProductName: req.formulaProductName,
            })),
        })),
    }));
}
